import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { ArticleOutlined } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import { primaryDark, accentColor } from "../../../constants/consts";

const popIn = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
`;

export default function KnowledgeDescDialog({ open, onClose, title, desc }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          animation: `${popIn} 0.25s cubic-bezier(0.22, 1, 0.36, 1) both`,
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 1.75,
          background: `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`,
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            color: "#fff",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <ArticleOutlined sx={{ fontSize: 20 }} />
          {title || "-"}
        </DialogTitle>
      </Box>

      <DialogContent sx={{ pt: 3 }}>
        {desc?.trim() ? (
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              backgroundColor: "#EFF6FF",
              color: "#1E293B",
              fontSize: 13.5,
              lineHeight: 1.6,
              whiteSpace: "pre-wrap",
              border: "1px solid #DBEAFE",
              maxHeight: "60vh",
              overflowY: "auto",
            }}
          >
            {desc}
          </Box>
        ) : (
          <Typography sx={{ color: "#94A3B8", fontSize: 13 }}>
            İçerik girilmemiş
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            px: 4,
            fontWeight: 700,
          }}
        >
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
}
